<template>
    <div class="custom-select">
        <div class="edit-table">
            <div class="title_2">预算信息</div>
            <vxe-toolbar v-if="!disabled" style="margin-left: 125px;">
                <template v-slot:buttons>
                    <vxe-button @click="openModal('one')">新增</vxe-button>
                    <vxe-button @click="clearFn()">清空</vxe-button>
                </template>
            </vxe-toolbar>
            <vxe-table :data="listTwo" style="margin-left: 125px;">
                <vxe-table-column min-width="150" field="feeBudgetCode" title="费用预算编码"></vxe-table-column>
                <vxe-table-column min-width="150" field="feeBudgetTypeName" title="费用预算类型"></vxe-table-column>
                <vxe-table-column min-width="150" field="budgetSubjectsName" title="预算科目名称"></vxe-table-column>
                <vxe-table-column min-width="150" field="canUseAmount" title="可用余额"></vxe-table-column>
                <vxe-table-column min-width="150" field="budgetYear" title="财年"></vxe-table-column>
                <vxe-table-column min-width="150" field="orgName" title="组织"></vxe-table-column>
                <vxe-table-column min-width="150" field="orgCode" title="组织编码"></vxe-table-column>
                <vxe-table-column min-width="150" field="customerName" title="经销商名称"></vxe-table-column>
                <vxe-table-column min-width="150" field="customerCode" title="经销商编码"></vxe-table-column>
                <vxe-table-column min-width="150" field="ext10" title="职位名称"></vxe-table-column>
                <vxe-table-column min-width="150" field="ext9" title="职位编码"></vxe-table-column>
                <vxe-table-column min-width="150" field="productLevelName" title="产品系列"></vxe-table-column>
                <vxe-table-column min-width="150" field="ext8" title="公司主体"></vxe-table-column>
                <vxe-column title="操作" width="80" v-if="!disabled">
                    <template #default="{ row, rowIndex }">
                        <template>
                            <span @click="deletRow(row, rowIndex)" style="color: red; cursor: pointer">删除</span>
                        </template>
                    </template>
                </vxe-column>
            </vxe-table>
            <div class="title_2">货补池信息</div>
            <vxe-toolbar v-if="!disabled" style="margin-left: 125px;">
                <template v-slot:buttons>
                    <vxe-button @click="addRow">新增</vxe-button>
                    <vxe-button @click="clearFn()">清空</vxe-button>
                </template>
            </vxe-toolbar>
            <vxe-table :data="listOne" style="margin-left: 125px;">
                <vxe-table-column min-width="200" field="createDateAll" title="预算信息">
                    <template #default="{ row, rowIndex }">
                        <el-select v-model="row.feeBudgetCode" @change="changeFeeBudgetCode($event, rowIndex)"
                            @focus="getFeeBudgetList(rowIndex)" placeholder="请选择预算信息" :disabled="disabled">
                            <el-option v-for="citem in listOne[rowIndex].ysOptions" :key="citem.value"
                                :label="citem.label" :value="citem.value">
                            </el-option>
                        </el-select>
                    </template>
                </vxe-table-column>
                <vxe-table-column disabled min-width="150" field="budgetYear" title="财年"></vxe-table-column>
                <vxe-table-column min-width="200" field="custName" title="经销商名称">
                    <template #default="{ row, rowIndex }">
                        <el-select v-model="row.custName" @change="changCust($event, rowIndex)"
                            @focus="() => getCustList(rowIndex)" :remote-method="v => getCustList(rowIndex, v)" remote clearable filterable placeholder="请选择经销商" :disabled="disabled">
                            <el-option v-for="item in listOne[rowIndex].custOptions" :key="item.custCode"
                                :label="item.custName" :value="item.custCode">
                            </el-option>
                        </el-select>
                    </template>
                </vxe-table-column>
                <vxe-table-column min-width="200" field="companyName" title="公司主体">
                    <template #default="{ row, rowIndex }">
                        <el-select v-model="row.companyName" @change="companyChange($event, rowIndex)"
                            placeholder="请选择公司主体" :disabled="disabled">
                            <el-option v-for="item in companyList" :key="item.companyCode" :label="item.companyName"
                                :value="item.companyCode">
                            </el-option>
                        </el-select>
                    </template>
                </vxe-table-column>
                <vxe-table-column min-width="200" field="productName" title="产品名称">
                    <template #default="{ row, rowIndex }">
                        <el-select v-model="row.productName" @change="choosePro($event, rowIndex)"
                            @focus="getProList(rowIndex)" placeholder="请选择产品" :disabled="disabled">
                            <el-option v-for="item in listOne[rowIndex].proOptions" :key="item.materialCode"
                                :label="item.materialName" :value="item.materialCode">
                            </el-option>
                        </el-select>
                    </template>
                </vxe-table-column>
                <vxe-table-column disabled min-width="150" field="unitPrice" title="产品单价"></vxe-table-column>
                <vxe-table-column min-width="150" field="transformNum" title="划转数量">
                    <template #default="{ row, rowIndex }">
                        <el-input v-model="row.transformNum" placeholder="请输入划转数量" :disabled="disabled"
                            @input="getTransformNum($event, rowIndex)"></el-input>
                    </template>
                </vxe-table-column>
                <vxe-table-column disabled min-width="150" field="transformCash" title="划转金额"></vxe-table-column>
                <vxe-table-column min-width="150" field="baseUnit" title="单位">瓶</vxe-table-column>
                <vxe-column title="操作" width="80" v-if="!disabled">
                    <template #default="{ row, rowIndex }">
                        <template>
                            <span @click="deletRowOne(row, rowIndex)" style="color: red; cursor: pointer">删除</span>
                        </template>
                    </template>
                </vxe-column>
            </vxe-table>

        </div>
        <!-- 弹框 -->
        <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
    </div>
</template>

<script>

import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';
import request from '@/found/utils/request';
import { get } from 'sortablejs';

export default {
  name: 'product_list',
  props: {
    value: [Array, Object],
    disabled: Boolean,

  },
  data() {
    return {
      listOne: [],
      listTwo: [],
      companyList: [],
      openType: '',
      ysOptions: [],
      // state: '',
    };
  },
  components: {
    SelectConfig,
  },
  created() {
    this.getCompanyList();
  },
  watch: {
    value: {
      handler(val) {
        console.log(val);
        if (val) {
          this.listOne = val.listOne || [];
          this.listTwo = val.listTwo || [];
        } else {
          this.listOne = [];
          this.listTwo = [];
        }
      },
    },
  },
  methods: {
    // 新增弹窗
    openModal(type) {
      this.openType = type;
      console.log(type);
      let params = {};
      if (type === 'one') {
        // 过滤掉已经存在的feeBudgetCode
        params = {
          functionCode: 'poollList',
          data: this.listTwo || [],
          idKey: 'feeBudgetCode',
          paramData: {
            enableStatus: '009',
            budgetSubjectsCode: 'YSKM000200',
          },

        };
      } else {
        params = {
          functionCode: 'customerList',
          data: [],
          idKey: 'id',
          paramData: {
            channelFeeCode: 'YS2501210059',
          },
        };
      }

      params.noReset = true;
      this.$refs.selectConfig.openSelectModal(params);
    },
    // 货补池新增
    addRow() {
      if (!this.listTwo.length) {
        this.$message({
          type: 'warning',
          message: '至少选择一条预算',
        });
        return;
      }
      console.log(this.ysOptions);
      this.listOne.push({
        feeBudgetCode: '',
        ysOptions: this.ysOptions,
        custOptions: [],
        proOptions: [],
        budgetYear: '',
        custName: '',
        custCode: '',
        companyName: '',
        companyCode: '',
        productName: '',
        productCode: '',
        unitPrice: '',
        transformCash: '',
        transformNum: '',
        baseUnit: 'bottle',

      });
    },
    // 选择预算
    changeFeeBudgetCode(row, index) {
      console.log(row, index);
      this.$set(this.listOne[index], 'feeBudgetCode', row);
      this.$set(this.listOne[index], 'custOptions', []);
      this.$set(this.listOne[index], 'custName', null);
      this.$set(this.listOne[index], 'custCode', null);
      this.$set(this.listOne[index], 'companyName', null);
      this.$set(this.listOne[index], 'companyCode', null);
      this.$set(this.listOne[index], 'productName', null);
      this.$set(this.listOne[index], 'productCode', null);
      this.$set(this.listOne[index], 'unitPrice', null);
      this.$set(this.listOne[index], 'transformNum', null);
      this.$set(this.listOne[index], 'transformCash', null);
      // 获取所选行的完整数据
      const selectedItem = this.listOne[index].ysOptions.find((item) => item.value === row);
      if (selectedItem) {
        this.$set(this.listOne[index], 'budgetYear', selectedItem.budgetYear);
        this.$set(this.listOne[index], 'productLevelCode', selectedItem.productLevelCode);
        this.$set(this.listOne[index], 'productLevelName', selectedItem.productLevelName);
        this.$set(this.listOne[index], 'orgCode', selectedItem.orgCode);
        this.$set(this.listOne[index], 'orgName', selectedItem.orgName);
      }
    },
    getFeeBudgetList(index) {
      console.log(this.listTwo);
      const ysOptions = [];
      this.listTwo.forEach((itt) => {
        ysOptions.push({
          label: itt.feeBudgetCode,
          value: itt.feeBudgetCode,
          budgetYear: itt.budgetYear,
          productLevelCode: itt.productLevelCode,
          productLevelName: itt.productLevelName,
          orgCode: itt.orgCode,
          orgName: itt.orgName,
        });
      });
      this.$set(this.listOne[index], 'ysOptions', ysOptions || []);
    },
    getCustList(index, customerName) {
      if (!this.listOne[index].feeBudgetCode) {
        this.$message({
          type: 'warning',
          message: '请选择预算',
        });
        return;
      }
      // request.post('/tpm/tpmawardtransform/findCustomerInfo', { channelFeeCode: this.listOne[index].feeBudgetCode }).then((rel) => {
      request.post('/mdm/mdmCustomerMsgExtController/findCustomerInfoByOrgCode', {
        orgCode: this.listOne[index].orgCode, enableStatus: '009', pageSize: 500, customerName,
      }).then((rel) => {
        if (rel.success) {
          console.log(rel);
          let resData = rel.result.data;
          resData = resData.map((v) => {
            const obj = v;
            obj.custCode = obj.customerCode;
            obj.custName = obj.customerName;
            return obj;
          });
          this.$set(this.listOne[index], 'custOptions', resData || []);
        } else {
          this.$set(this.listOne[index], 'custOptions', []);
        }
      }).catch((err) => {
        console.log('err', err);
      });
    },
    // 选择经销商
    changCust(row, index) {
      this.$set(this.listOne[index], 'custCode', row);
      const res = this.listOne[index].custOptions.find(
        (item) => item.custCode === row,
      );
      this.$set(this.listOne[index], 'custName', res.custName);
      this.$emit('input', { listOne: this.listOne, listTwo: this.listTwo });
      this.$emit('change', { listOne: this.listOne, listTwo: this.listTwo });
    },
    // 选择公司主体
    companyChange(row, index) {
      console.log(row, index);
      this.$set(this.listOne[index], 'companyCode', row);
      const res = this.companyList.find(
        (item) => item.companyCode === row,
      );
      this.$set(this.listOne[index], 'companyName', res.companyName);
      this.$emit('input', { listOne: this.listOne, listTwo: this.listTwo });
      this.$emit('change', { listOne: this.listOne, listTwo: this.listTwo });
      console.log(this.listOne);
    },
    getCompanyList() {
      request.post('/mdm/companyInfo/companyPageList ', { flagBan: '1', pageNum: 1, pageSize: 1000 }).then((res) => {
        console.log(res);
        if (res.success) {
          this.companyList = res.result.data || [];
        }
      });
    },
    getProList(index) {
      console.log(this.listOne[index]);
      if (!this.listOne[index].feeBudgetCode) {
        this.$message({
          type: 'warning',
          message: '请选择预算',
        });
        return;
      }
      if (!this.listOne[index].companyCode) {
        this.$message({
          type: 'warning',
          message: '请选择公司主体',
        });
        return;
      }
      request.post('/mdm/mdmMaterialExtController/pageList', {
        pageNum: 1, pageSize: 1000, code: this.listOne[index].productLevelCode,
      }).then((rel) => {
        if (rel.success) {
          console.log(rel);
          this.$set(this.listOne[index], 'proOptions', rel.result.data || []);
        } else {
          this.$set(this.listOne[index], 'proOptions', []);
        }
      }).catch((err) => {
        console.log('err', err);
      });
    },
    // 选择产品
    choosePro(row, index) {
      this.$set(this.listOne[index], 'productCode', row);
      const res = this.listOne[index].proOptions.find(
        (item) => item.materialCode === row,
      );
      console.log(this.listOne);
      this.$set(this.listOne[index], 'productName', res.materialName);
      request.post('/tpm/tpmawardtransform/findTransFormInfo', {
        companyCode: this.listOne[index].companyCode,
        productCode: this.listOne[index].productCode,
      }).then((rel) => {
        if (rel.success) {
          console.log(rel);
          this.$set(this.listOne[index], 'unitPrice', rel.result.unitPrice || '');
        } else {
          this.$set(this.listOne[index], 'unitPrice', null);
        }
      }).catch((err) => {
        this.$set(this.listOne[index], 'unitPrice', null);
      });
      this.$emit('input', { listOne: this.listOne, listTwo: this.listTwo });
      this.$emit('change', { listOne: this.listOne, listTwo: this.listTwo });
    },
    // 添加:处理划转数量变化并计算划转金额
    getTransformNum(value, index) {
      // 获取输入的划转数量
      const transformNum = parseFloat(value);
      const unitPrice = parseFloat(this.listOne[index].unitPrice);

      // 计算划转金额
      if (!Number.isNaN(transformNum) && !Number.isNaN(unitPrice) && transformNum !== null && unitPrice !== null) {
        const transformCash = transformNum * unitPrice;
        this.$set(this.listOne[index], 'transformCash', transformCash.toFixed(2));
      } else {
        this.$set(this.listOne[index], 'transformCash', '');
      }

      // 更新划转数量值
      this.$set(this.listOne[index], 'transformNum', Number.isNaN(transformNum) ? '' : transformNum);

      this.$emit('input', { listOne: this.listOne, listTwo: this.listTwo });
      this.$emit('change', { listOne: this.listOne, listTwo: this.listTwo });
    },
    // 选择回调
    onGetSelect(val) {
      console.log(val);
      if (this.openType === 'one') {
        // 过滤掉已经存在的feeBudgetCode
        const newVals = val.filter((newItem) => !this.listTwo.some((existingItem) => existingItem.feeBudgetCode === newItem.feeBudgetCode));

        newVals.forEach((it) => {
          const itt = it;
          this.ysOptions.push({
            label: itt.feeBudgetCode,
            value: itt.feeBudgetCode,
            budgetYear: itt.budgetYear,
            productLevelCode: itt.productLevelCode,
            productLevelName: itt.productLevelName,
            orgCode: itt.orgCode,
            orgName: itt.orgName,
          });
        });
        this.listTwo = [...this.listTwo, ...newVals];
      }

      //   this.listOne = val;

      this.$emit('input', { listOne: this.listOne, listTwo: this.listTwo });
      this.$emit('change', { listOne: this.listOne, listTwo: this.listTwo });
    },
    // 清除选择
    clearFn() {
      this.listOne = [];
      this.listTwo = [];
      this.$emit('input', { listOne: this.listOne, listTwo: this.listTwo });
      this.$emit('change', { listOne: this.listOne, listTwo: this.listTwo });
    },
    deletRow(row, index) {
      console.log(row, index);
      const feeCode = row.feeBudgetCode;

      // 删除listTwo中的当前行
      this.listTwo.splice(index, 1);

      // 删除listOne中与当前行feeBudgetCode相同的行
      this.listOne = this.listOne.filter((item) => item.feeBudgetCode !== feeCode);
      console.log(this.listOne);
      this.listOne.forEach((item) => {
        item.ysOptions = item.ysOptions.filter((option) => option.value !== feeCode);
      });

      this.$emit('input', { listOne: this.listOne, listTwo: this.listTwo });
      this.$emit('change', { listOne: this.listOne, listTwo: this.listTwo });
    },
    deletRowOne(row, index) {
      console.log(row, index);
      this.listOne.splice(index, 1);
      this.$emit('input', { listOne: this.listOne, listTwo: this.listTwo });
      this.$emit('change', { listOne: this.listOne, listTwo: this.listTwo });
    },
  },
};
</script>

<style lang="less" scoped>
.title_2 {
font-size: 16px;
    height: 20px;
    line-height: 20px;
    font-weight: 600;
    margin-top: 30px;
    margin-bottom: 18px;
}
.edit-table{
    margin-left: 0 !important;
}
</style>
